import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "./CircularSlider.css";

const CircularSlider = () => {
  const navigate = useNavigate();

  const images = [
    { src: "/images/LifeInsurance.jpg", title: "Life Insurance", section: "insurance" },
    { src: "/images/e43.jpg", title: "Health Insurance", section: "insurance" },
    { src: "/images/insura.jpg", title: "General Insurance", section: "insurance" },
    { src: "/images/e90.jpeg", title: "Home Loan", section: "loans" },
    { src: "/images/e52.jpg", title: "Personal Loan", section: "loans" },
    { src: "/images/muttal.jpg", title: "Mutual Funds", section: "mutual" },
    { src: "/images/sip.jpg", title: "SIP Investments", section: "mutual" }
  ];

  const handleSlideClick = (sectionId) => {
    navigate("/our-services", { state: { scrollTo: sectionId } });
  };

  return (
    <section className="slider-container">
      <h2 className="slider-heading">Explore Your Products</h2>

      <Swiper
        modules={[Navigation, Autoplay]}
        centeredSlides
        slidesPerView={3}     /* 🔥 ALWAYS 3 */
        spaceBetween={40}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false
        }}
        navigation
        loop
        speed={500}
        className="mySwiper"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div
              className="slide-content"
              onClick={() => handleSlideClick(image.section)}
              style={{ cursor: "pointer" }}
            >
              <img src={image.src} alt={image.title} loading="lazy" />
              <div className="slide-title">{image.title}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default CircularSlider;
